import styled from '@emotion/styled'

import { NativeLink, spacing, typography } from 'main/ui'

const columns = 3
const gutter = spacing.majorScale(2)

export const approximateImageSize = 250

export const PhotosContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin-bottom: -${gutter}px;
  margin-right: -${gutter}px;
  margin-top: ${spacing.majorScale(2)}px;
`

export const PhotoContainer = styled.a`
  cursor: pointer;
  height: calc((100% / ${columns}) - ${gutter}px);
  margin-bottom: ${gutter}px;
  margin-right: ${gutter}px;
  width: calc((100% / ${columns}) - ${gutter}px);
`

export const ViewAllContainer = styled.div`
  margin-top: ${spacing.majorScale(2)}px;
`

export const ViewAllNativeLink = styled(NativeLink)`
  font-weight: ${typography.fontWeight.bold};
`
